module.exports = __webpack_public_path__ + "static/media/003.c86d6830.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/normals/003.jpg
// module id = 476
// module chunks = 0